import React from 'react';
import Button from '../../../components/ui/Button';

const BulkActions = ({ selectedCount, onExport, onDelete, onMoveToFolder, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-20 lg:bottom-6 left-4 right-4 lg:left-auto lg:right-6 z-50">
      <div className="bg-card border border-border rounded-lg shadow-xl p-4 max-w-2xl mx-auto lg:ml-auto">
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <div className="flex items-center gap-2 text-sm font-medium text-foreground">
            <span className="bg-primary text-primary-foreground rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold">
              {selectedCount}
            </span>
            <span>prompt{selectedCount !== 1 ? 's' : ''} selected</span>
          </div>

          <div className="flex items-center gap-2 flex-wrap justify-center sm:justify-start flex-1">
            <Button
              variant="outline"
              size="sm"
              iconName="FolderInput"
              iconPosition="left"
              onClick={onMoveToFolder}
            >
              Move
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onExport}
            >
              Export
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={onDelete}
            >
              Delete
            </Button>
          </div>

          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;